module.exports = __webpack_public_path__ + "img/logoVueJS.35f43f24.svg";